import { NotificationType } from '@store/slices/notification/notification';

export const notificationInstance = (
  userNote: any
): NotificationType | null => {
  const notification = userNote?.notifications?.[0];

  if (!notification) return null;

  return {
    id: notification.id,
    createdAt: notification.createdAt,
    isRead: notification.read,
    memberImage: null,
    memberName: null,
    orderingValue: null,
    rideDate: null,
    rideId: null,
    rideSupportUrl: null,
    rideType: null,
    statusId: null,
    statusName: null,
    userId: notification.userId,
    vehiclesImage: null,
  };
};
